/**
 * Row-cell link from an operations-dashboard grid row to the site's
 * dashboard page. Renders as plain text when the row lacks a resolvable
 * site (e.g. a site-group-level summary row).
 *
 * Contains:
 * - SiteLink — default export
 */

import Link from '@mui/material/Link';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export default function SiteLink({ customerId, siteGroupId, siteId, children }) {
  if (!siteId || !siteGroupId) return children;
  return (
    <Link
      component={RouterLink}
      to={`/c/${customerId}/plant/${siteGroupId}/structure/${siteId}`}
      underline="none"
      sx={{
        color: 'primary.main',
        '&:visited': { color: 'primary.main' },
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Link>
  );
}
